import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

const RECAPTCHA_SITE_KEY = window.Cypress
  ? process.env.REACT_APP_RECAPTCHA_SITE_KEY_CYPRESS
  : process.env.REACT_APP_RECAPTCHA_SITE_KEY;

ReactDOM.render(
  <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY} language={['es']}>
    <App />
  </GoogleReCaptchaProvider>,
  document.getElementById('root'),
);
